module.exports = __webpack_public_path__ + "static/media/05_3.a3fe0ae9.png";